// Standalone /data-dictionary page — the person-record reference. Routed at the top level in
// index.js (same pattern as /privacy-policy), so it renders outside the campaign app shell.
// The content is the self-contained static doc in public/data-dictionary.html; we embed it in a
// full-viewport iframe so its page-level styles stay fully isolated.
export default function DataDictionary() {
  return (
    <iframe
      title="Pollis — Person Data Dictionary"
      src={`${process.env.PUBLIC_URL || ""}/data-dictionary.html`}
      style={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  );
}
